export const generalFaq = [
  {
    id: 1,
    question: "What is Snappily?",
    answer:
      "Snappily provides tools for by-the-room property management.  Whether you're sharing an apartment with college buddies, our building a house hacking empire, Snappily helps simplify everything.",
  },
  {
    id: 2,
    question: "Who should use Snappily?",
    answer:
      "College students looking to split an apartment. House hackers, looking to simplify their management tasks. Anyone that want's to turn an empty bedroom into monthly cashflow.",
  },
  {
    id: 3,
    question: "Can Snappily help me find tenants?",
    answer:
      "Yes. Posting rooms for rent is FREE and easy. Not only will your room be searchable on the Snappily website, it will also be posted to several other room-for-rent websites.",
  },
  {
    id: 4,
    question: "How does rent collection work?",
    answer: `On the 1<sup>st</sup> of every month, your tenants are informed that rent is due.  They'll have the option to pay via ACH transfer, credit or debit card, cash, or check, via the tenant portal.`,
  },
  {
    id: 5,
    question:
      "Is there a way for me to communicate with my tenants through the Snappily App?",
    answer:
      "Yes.  Snappily has in-app messaging so you can keep all your rental related communications in one location.",
  },
  {
    id: 6,
    question: "Why type of properties can I manage with Snappily?",
    answer:
      "You can manage any property that has one or more bedroom for rent.",
  },
];

export const leasesFaq = [
  {
    id: 1,
    question: "Do I need to pay extra to create leases with Snappily?",
    answer: "Absolutely not!",
  },
  {
    id: 2,
    question:
      "I just want a lease template that I can reuse.  Do you offer lease templates?",
    answer:
      "No.  We do not offer lease templates for sale.  However, you can create and print a customized lease for every tenant that you add or invite to you property.  These leases can be downloaded or printed.",
  },
  {
    id: 3,
    question: "How do I customize my leases.",
    answer:
      "Snappily will guide you through a series of simple questions, that will help us create the perfect lease for your situation.  We cover a wide range of scenarios from splitting bills and handling pet deposits, to late fees and pro-rated rents.",
  },
  {
    id: 4,
    question: "Will your lease be valid in my State?",
    answer:
      "Absolutely!  Snappily has taken great care to incorporate State specific laws into each lease.  Every State has their own laws defining things like grace periods, late fees, security deposits, and more.  Each lease that you create will be optimized for the State in which your property is located.",
  },
  {
    id: 5,
    question: "Will I be able to print and download my leases?",
    answer:
      "Yes.  All of your leases will be stored in the app, for you to view, print, or download at your convenience.  Your tenants will bbe able to view their respective leases as well.",
  },
];

export const pricingFaq = [
  {
    id: 1,
    question: "How much does it cost to use Snappily?",
    answer:
      "Snappily offers three subscription tiers: <br/><br/><b>BASIC (FREE):</b> ONE tenant and ONE property.<br/><br/><b>PREMIUM ($19.99/mth):</b> Up to FOUR tenants and TWO properties.<br/><br/><b>PROFESSIONAL ($49.99/mth):</b> UNLIMITED tenants and properties.<br/><br/>",
  },
  {
    id: 2,
    question: "What does the BASIC subscription include?",
    answer:
      "The BASIC subscription gives you access to all of Snappily's features for ONE tenant and ONE property. This subscription is completely FREE!",
  },
  {
    id: 3,
    question: "What does the PREMIUM subscription include?",
    answer:
      "The PREMIUM subscription gives you access to all of Snappily's features for up to FOUR tenants and TWO properties. This subscription is $19.99/mth.",
  },
  {
    id: 4,
    question: "What does the PROFESSIONAL subscription include?",
    answer:
      "The PROFESSIONAL subscription gives you access to all of Snappily's features for an UNLIMITED number of tenants and properties. This subscription is $49.99/mth.",
  },
];
